import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./send-email.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./send-email.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SendEmailConstants } from "./send-email.constants";
import { UserInformationService } from "../../services/user/user-information.service";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { SendEmailService } from "./service/send-email.service";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { SendLetterService } from "../send-letter/service/send-letter.service";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { APP_BASE_HREF } from "@angular/common";
import RecipientUtils from "../../utils/recipient-utils";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ModuleConfig } from "../../models/module-config.model";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { WorkflowJobService } from "../../services/workflow-job/workflow-job.service";
import { CurrentStepService } from "../../services/current-step/current-step.service";
let SendEmailComponent = class SendEmailComponent {
    baseHref;
    changeDetectionRef;
    userInformation;
    sendEmailService;
    aflaModuleStrategyService;
    sendLetterService;
    appController;
    saShortDatePipe;
    workflowJobService;
    currentStepService;
    userInformationService;
    recipients;
    currentStepName = "";
    hideAddDefaultTemplate = false;
    hideAttachmentManager = false;
    attachmentManagerAttachmentType;
    attachmentManagerTitle;
    attachmentManagerJobId;
    communicationType;
    autoSendDetails;
    linkToReplace;
    sendEmailButtonDisabled = false;
    infoLabel = "";
    currentLink;
    commentRequestGuid;
    viewDocumentsRequestGuid;
    anonymousAccess = { anonymousDocumentAccess: false };
    isCommentRequestStep = false;
    emailSent = new EventEmitter();
    configurationName;
    hideAddAttachmentButton = false;
    hideDeleteAttachmentButton = false;
    hideFilter;
    hideAdd = false;
    hideDelete = false;
    allowPropertySelector = false;
    templateRequired = false;
    currentStepType = "";
    sendEmailForm;
    emailSenderLabel = SendEmailConstants.EMAIL_SENDER_LABEL;
    emailSenderControl = SendEmailConstants.EMAIL_SENDER_CONTROL;
    validationMessage = SendEmailConstants.VALIDATION_MESSAGES;
    emailTemplateLabel = SendEmailConstants.EMAIL_TEMPLATE_LABEL;
    selectPropertyLabel = SendEmailConstants.SELECT_PROPERTY_LABEL;
    emailSubjectLabel = SendEmailConstants.EMAIL_SUBJECT_LABEL;
    emailSubjectControl = SendEmailConstants.EMAIL_SUBJECT_CONTROL;
    selectedTemplateFromDropdown;
    emailTextLabel = SendEmailConstants.EMAIL_TEXT_LABEL;
    emailTextControl = SendEmailConstants.EMAIL_TEXT_CONTROL;
    addDefaultTemplateAttachmentLabel = SendEmailConstants.TEMPLATE_ATTACHMENT_LABEL;
    addDefaultTemplateChecked = false;
    sendEmailLabel = SendEmailConstants.SEND_EMAIL_LABEL;
    attachmentManagerFormControl = SendEmailConstants.ATT_MANAGER_CONTROL;
    commsType = SendEmailConstants.adHocComms;
    emailTemplates = [];
    setSelectAttachmentRequired = false;
    // public moduleId;
    componentName = SendEmailConstants.COMPONENT_NAME;
    application;
    currentUser;
    noRecipientErrMsg = SendEmailConstants.NO_RECIPIENT_ERR_MSG;
    emailSentMsg = SendEmailConstants.alertMessages.sendEmailSuccessful;
    invalidTemplateTypes = SendEmailConstants.invalidTemplateTypes;
    description;
    toEmail = [];
    ccEmail = [];
    bccEmail = [];
    attachments = [];
    noCommunicationTypeErrMsg = SendEmailConstants.noCommunicationTypeErrMsg;
    noSubjectErrMsg = SendEmailConstants.noSubjectErrMsg;
    noTemplateErrMsg = SendEmailConstants.noTemplateErrMsg;
    noEmailTextErrMsg = SendEmailConstants.noEmailTextErrMsg;
    emailTextConstant = SendEmailConstants.emailTextConst;
    bothTextConst = SendEmailConstants.bothTextCont;
    emailCommMechConst = SendEmailConstants.emailCommMechConst;
    emailCommDirectionConst = SendEmailConstants.emailCommDirectionConst;
    jobIdTextPlaceholder = SendEmailConstants.stringPlaceholders.jobId;
    selectedTextPlaceholder = SendEmailConstants.stringPlaceholders.selected;
    emailFieldTextPlaceholder = SendEmailConstants.stringPlaceholders.emailField;
    consolidatedGroupTextPlaceholder = SendEmailConstants.stringPlaceholders.consolidatedGroup;
    applicationStatus = null;
    cemeteryName;
    cemeteryId;
    plotNumber;
    populateEmailSenderSubscription;
    getEmailTemplatesSubscription;
    logCommunicationSubscription;
    postEmailSubscription;
    properties = new Array();
    selectedProperty;
    getApplicationsQuerySubscription;
    getApplicationStatusSubscription;
    constructor(baseHref, changeDetectionRef, userInformation, sendEmailService, aflaModuleStrategyService, sendLetterService, appController, saShortDatePipe, workflowJobService, currentStepService, userInformationService) {
        this.baseHref = baseHref;
        this.changeDetectionRef = changeDetectionRef;
        this.userInformation = userInformation;
        this.sendEmailService = sendEmailService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.sendLetterService = sendLetterService;
        this.appController = appController;
        this.saShortDatePipe = saShortDatePipe;
        this.workflowJobService = workflowJobService;
        this.currentStepService = currentStepService;
        this.userInformationService = userInformationService;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty("linkToReplace")) {
            this.linkToReplace = changes.linkToReplace.currentValue;
            this.onSelectTemplateChanged();
        }
    }
    ngOnInit() {
        if (this.isCommentRequestStep) {
            this.anonymousAccess.anonymousCommentRequestAccess = true;
        }
        this.initForm();
        this.populateEmailSender();
        this.getEmailTemplates();
        this.getApplicantData();
        this.autoSendEmail();
    }
    onSelectTemplateChanged() {
        if (this.selectedTemplateFromDropdown !== undefined) {
            const emailSubject = this.replaceKeyWords(this.selectedTemplateFromDropdown.emailSubject);
            const emailBody = this.replaceKeyWords(this.selectedTemplateFromDropdown.template);
            this.sendEmailForm.get(this.emailSubjectControl).setValue(emailSubject);
            this.sendEmailForm.get(this.emailTextControl).setValue(emailBody);
            if (this.selectedTemplateFromDropdown.attachmentId !== null) {
                this.addDefaultTemplateChecked = true;
            }
            else {
                this.addDefaultTemplateChecked = false;
            }
        }
    }
    onSelectProperty() {
        if (this.selectedProperty && this.selectedProperty !== undefined && this.selectedTemplateFromDropdown !== undefined) {
            const emailSubject = this.replaceKeyWords(this.selectedTemplateFromDropdown.emailSubject);
            const emailBody = this.replaceKeyWords(this.selectedTemplateFromDropdown.template);
            this.sendEmailForm.get(this.emailSubjectControl).setValue(emailSubject);
            this.sendEmailForm.get(this.emailTextControl).setValue(emailBody);
        }
    }
    onAddDefaultTemplateChecked($event) {
        const defaultChecked = $event.target.value;
        if (defaultChecked) {
            this.addDefaultTemplateChecked = true;
        }
        else {
            this.addDefaultTemplateChecked = false;
        }
    }
    sendEmailClicked() {
        this.description = "";
        const emailSender = this.getEmailSender();
        this.setEmailReceiverAddresses();
        if (this.toEmail.length === 0 ? true : false) {
            this.appController.showMessage(this.noRecipientErrMsg, AlertType.Warning);
            return;
        }
        if (this.communicationType === null || this.communicationType === undefined) {
            this.appController.showMessage(this.noCommunicationTypeErrMsg, AlertType.Warning);
            this.markFormControlsAsTouched();
            return;
        }
        if (this.sendEmailForm.get(this.emailSubjectControl).value === null ||
            this.sendEmailForm.get(this.emailSubjectControl).value === undefined) {
            this.appController.showMessage(this.noSubjectErrMsg, AlertType.Warning);
            this.markFormControlsAsTouched();
            return;
        }
        if (this.templateRequired && (this.selectedTemplateFromDropdown === undefined || this.selectedTemplateFromDropdown === null)) {
            this.appController.showMessage(this.noTemplateErrMsg, AlertType.Warning);
        }
        const emailSubject = this.getEmailSubject();
        if (this.sendEmailForm.get(this.emailTextControl).value === null ||
            this.sendEmailForm.get(this.emailTextControl).value === undefined) {
            this.appController.showMessage(this.noEmailTextErrMsg, AlertType.Warning);
            this.markFormControlsAsTouched();
            return;
        }
        const emailBody = this.getEmailText();
        const emailAttachmentIds = this.getAttachments();
        this.generateEmail(emailSender, emailSubject, emailBody, emailAttachmentIds, this.anonymousAccess);
    }
    markFormControlsAsTouched() {
        Object.keys(this.sendEmailForm.controls).forEach((controlName) => {
            this.sendEmailForm.get(controlName).markAsTouched();
        });
        this.changeDetectionRef.detectChanges();
    }
    showInfoLabel() {
        return this.infoLabel !== "" ? true : false;
    }
    initForm() {
        this.sendEmailForm = new FormGroup({
            emailSender: new FormControl(null, Validators.required),
            emailSubject: new FormControl(null, Validators.required),
            emailText: new FormControl(null, Validators.required),
            attachmentManager: new FormControl(null)
        });
    }
    populateEmailSender() {
        this.populateEmailSenderSubscription = this.userInformation.$authenticatedUser.subscribe((user) => {
            this.currentUser = user;
            this.sendEmailForm.get(this.emailSenderControl).setValue(this.currentUser.email);
        });
    }
    getEmailTemplates() {
        this.getEmailTemplatesSubscription = this.sendEmailService.getEmailTemplates(this.currentStepName, +this.appController.selectedModuleID).subscribe({
            next: (response) => {
                this.onGetEmailTemplatesCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Add);
            }
        });
    }
    onGetEmailTemplatesCompleted(response) {
        const templatesArray = response.value;
        templatesArray.forEach((template) => {
            if (template.type.toLowerCase() === this.emailTextConstant || template.type.toLowerCase() === this.bothTextConst) {
                if (this.currentStepName === this.commsType) {
                    template.name = `${template.name} - ${template.stepName}`;
                    this.emailTemplates.push(template);
                }
                else if (template.stepName === this.currentStepName &&
                    (template.type.toLowerCase() === this.emailTextConstant || template.type.toLowerCase() === this.bothTextConst)) {
                    this.emailTemplates.push(template);
                }
                this.emailTemplates.sort((a, b) => (a.name.localeCompare(b.name)));
            }
        });
        this.changeDetectionRef.detectChanges();
    }
    getPeriod(stepFrom, stepTo) {
        let period = "";
        const fromAuditActions = this.application.auditActions.filter(x => x.description.includes(stepFrom));
        const toAuditActions = this.application.auditActions.filter(x => x.description.includes(stepTo));
        if (fromAuditActions && fromAuditActions.length > 0) {
            const fromAuditAction = fromAuditActions.reduce((max, obj) => (obj.id > max.id ? obj : max), fromAuditActions[0]);
            const dateFromString = this.saShortDatePipe.transform(fromAuditAction.date);
            period = `${dateFromString} -`;
        }
        if (toAuditActions && toAuditActions.length > 0) {
            const toAuditAction = toAuditActions.reduce((max, obj) => (obj.id > max.id ? obj : max), toAuditActions[0]);
            const dateToString = this.saShortDatePipe.transform(toAuditAction.date);
            period += dateToString;
        }
        return period;
    }
    getRejector(step) {
        let rejector = "";
        let rejectors = this.application.auditActions.filter(x => x.componentIdentifier.includes(step));
        rejectors = this.sortByDateDescending(rejectors);
        if (rejectors && rejectors.length > 0) {
            const rejectorUser = rejectors[0].user;
            rejector = rejectorUser.firstName + " " + rejectorUser.lastName;
        }
        return rejector;
    }
    sortByDateDescending(arr) {
        return arr.sort((a, b) => {
            return new Date(b.date).getTime() - new Date(a.date).getTime();
        });
    }
    replaceKeyWords(stringToBeReplace) {
        const appId = this.application.appId.toString();
        const jobId = this.attachmentManagerJobId.toString();
        const userName = this.currentUser.firstName;
        const userSurname = this.currentUser.lastName;
        const userEmail = this.currentUser.email;
        const category = this.applicationStatus ? this.applicationStatus.category : "";
        const linkToReplace = this.linkToReplace === undefined ? "Template has no link / Link has not been copied" : this.linkToReplace;
        let applicantEmail = "";
        let applicantName = "";
        let applicantTelephone = "";
        let applicantSurname = "";
        const referenceNumber = this.application.referenceNumber;
        const phoneNumber = this.currentUser.phoneNumber;
        let applicantAgentEmail = "";
        let applicantAgentName = "";
        let applicantAgentTelephone = "";
        let applicantAgentSurname = "";
        const moduleId = this.appController.selectedModuleID;
        const organisationId = this.userInformationService.getOrganisationId(+moduleId);
        let moduleName = "";
        let organisationName = "";
        let status = "";
        let percentageComplete = "";
        let graveId = "";
        let plotNumber = "";
        let cemeteryName = "";
        let erfNo = "";
        let farmNo = "";
        let portion = "";
        let address = "";
        let propertyOwner = "";
        let propertyValuationMethod = "";
        let propertyExtentSize = "";
        let objectionPeriod = "";
        let appealsPeriod = "";
        let propertyValuation = "";
        let applicationStartDate = "";
        let applicationCreatedDate = "";
        let applicationCreatedByName = "";
        let applicationCreatedBySurname = "";
        let applicationPhase = "";
        let applicationLastEditedByName = "";
        let applicationLastEditedBySurname = "";
        let rejector = "";
        // these two should be configured as dynamic keywords on the step metadata
        let featureName = "";
        let applicationDescription = "";
        if (this.aflaModuleStrategyService.name === ModuleConfig.PropertyValuation && this.application.properties && this.application.properties.length > 0) {
            objectionPeriod = this.getPeriod("Moved to step : Capture objection", "Moved to step : Send updated roll report to the municipality - objections");
            appealsPeriod = this.getPeriod("Moved to step : Capture appeal", "Moved to step : Send updated roll report to the municipality - appeals");
        }
        if (this.aflaModuleStrategyService.name === ModuleConfig.Mondi) {
            rejector = this.getRejector("Capture modification reason");
        }
        if (this.aflaModuleStrategyService.name === ModuleConfig.PropertyValuation) {
            let valuations;
            if (this.selectedProperty)
                valuations = this.selectedProperty.valuations[0];
            else
                valuations = this.application.properties[0].valuations[0];
            if (this.application.properties && this.application.properties.length > 0 && valuations !== undefined && valuations !== null) {
                if (valuations.hasOwnProperty("improvement") && valuations.improvement !== null) {
                    propertyExtentSize = valuations.improvement.toString();
                }
                if (valuations.hasOwnProperty("openMarketValue") && valuations.openMarketValue !== null) {
                    propertyValuation = valuations.openMarketValue;
                }
            }
        }
        if (this.application.graves !== undefined && this.application.graves !== null) {
            const grave = this.application.graves[0];
            if (grave) {
                graveId = grave.id.toString();
                cemeteryName = grave.cemeteryName;
                plotNumber = grave.plotNumber ? grave.plotNumber : "";
            }
        }
        if (this.application.properties !== undefined && this.application.properties !== null) {
            let property;
            if (this.selectedProperty) {
                property = this.selectedProperty;
            }
            else {
                property = this.application.properties[0];
            }
            if (property) {
                erfNo = property.erfNumber ? property.erfNumber : "";
                farmNo = property.farmNumber ? property.farmNumber : "";
                portion = property.subdivision ? property.subdivision : "";
                address = property.address ? property.address : "";
                if (property.owners && Array.isArray(property.owners)) {
                    property.owners.forEach(owner => {
                        propertyOwner += `${owner.name} ${owner.surname}, `;
                    });
                    propertyOwner = propertyOwner.slice(0, -2);
                }
                else {
                    propertyOwner = "";
                }
            }
        }
        if (this.application.createdSystemUser !== undefined && this.application.createdSystemUser !== null) {
            applicationCreatedByName = this.application.createdSystemUser.firstName;
            applicationCreatedBySurname = this.application.createdSystemUser.lastName;
        }
        if (this.application.lastEditedUser !== undefined && this.application.lastEditedUser !== null) {
            applicationLastEditedByName = this.application.lastEditedUser.firstName;
            applicationLastEditedBySurname = this.application.lastEditedUser.lastName;
        }
        if (this.applicationStatus !== undefined && this.applicationStatus !== null) {
            status = this.applicationStatus.workflowSection;
            percentageComplete = this.applicationStatus.percentageComplete ? this.applicationStatus.percentageComplete.toString() : "";
            applicationPhase = this.applicationStatus.workflowSection;
        }
        if (moduleId !== undefined && moduleId !== null) {
            const module = this.userInformationService.getModuleInformation(+moduleId);
            if (module !== undefined && module !== null) {
                moduleName = module.name;
            }
        }
        if (organisationId !== undefined && organisationId !== null) {
            const organisation = this.userInformationService.getOrganisationInformation(organisationId);
            if (organisation !== undefined && organisation !== null) {
                organisationName = organisation.name;
            }
        }
        if (this.application.applicant !== undefined && this.application.applicant !== null && this.application.applicant.length > 0) {
            const applicant = this.application.applicant[0];
            applicantEmail = applicant.email;
            applicantName = applicant.name;
            applicantTelephone = applicant.telephone;
            applicantSurname = applicant.surname;
        }
        if (this.application.applicantAgent !== undefined && this.application.applicantAgent !== null && this.application.applicantAgent.length > 0) {
            const applicantAgent = this.application.applicantAgent[0];
            applicantAgentEmail = applicantAgent.email;
            applicantAgentName = applicantAgent.name;
            applicantAgentTelephone = applicantAgent.telephone;
            applicantAgentSurname = applicantAgent.surname;
        }
        if (this.application.applicantAgent !== undefined && this.application.applicantAgent !== null && this.application.applicantAgent.length > 0) {
            const applicantAgent = this.application.applicantAgent[0];
            applicantAgentEmail = applicantAgent.email;
            applicantAgentName = applicantAgent.name;
            applicantAgentTelephone = applicantAgent.telephone;
            applicantAgentSurname = applicantAgent.surname;
        }
        if (this.aflaModuleStrategyService.name === ModuleConfig.Mondi) {
            featureName = this.application.featureName;
            applicationDescription = this.application.locationDetail;
        }
        else {
            applicationDescription = this.application.description;
        }
        applicationCreatedDate = this.saShortDatePipe.transform(this.application.createdDate);
        applicationStartDate = this.saShortDatePipe.transform(this.application.startDate);
        propertyValuationMethod = this.application.method;
        let applicationUrl = window.location.origin;
        if (this.baseHref !== undefined && this.baseHref !== null && this.baseHref !== "") {
            applicationUrl += this.baseHref;
        }
        if (!applicationUrl.endsWith("/")) {
            applicationUrl += "/";
        }
        applicationUrl += +this.appController.selectedModuleID + "/viewapplication/" + jobId + "/content/details";
        const applicationAHref = "<a class='text-underline-hover' href=\"" + applicationUrl + "\">" + applicationUrl + "</a>";
        let requestCommentUrl = window.location.origin;
        if (this.baseHref !== undefined && this.baseHref !== null && this.baseHref !== "") {
            requestCommentUrl += this.baseHref;
        }
        if (!requestCommentUrl.endsWith("/")) {
            requestCommentUrl += "/";
        }
        requestCommentUrl += "unsecure/captureComment/" + this.commentRequestGuid;
        const requestCommentAHref = "<a class='text-underline-hover' href=\"" + requestCommentUrl + "\">" + requestCommentUrl + "</a>";
        let viewDocumentsLink = window.location.origin;
        if (this.baseHref !== undefined && this.baseHref !== null && this.baseHref !== "") {
            viewDocumentsLink += this.baseHref;
        }
        if (!viewDocumentsLink.endsWith("/")) {
            viewDocumentsLink += "/";
        }
        viewDocumentsLink += "unsecure/viewDocuments/" + "{documentGuid}";
        const viewDocumentsAHref = "<a class='text-underline-hover' href=\"" + viewDocumentsLink + "\">" + viewDocumentsLink + "</a>";
        const replacedText = stringToBeReplace.replace(/{AppId}|{JobId}|{ApplicantName}|{ApplicantPhoneNo}|{ApplicantSurname}|{ApplicantEmail}|{ApplicantAgentName}|{ApplicantAgentPhoneNo}|{ApplicantAgentSurname}|{ApplicantEmail}|{ApplicantAgentEmail}|{RefNo}|{ReferenceNumber}|{UserName}|{UserSurname}|{UserEmail}|{UserPhoneNo}|{ModuleId}|{ModuleName}|{OrganisationName}|{Status}|{Category}|{PercentageComplete}|{LINK_TO_SURVEY_URL}|{LINK_TO_APPLICATION_URL}|{LINK_TO_REQUEST_COMMENT_URL}|{viewDocumentsLink}|{GraveID}|{PlotNumber}|{CemeteryName}|{ErfNumber}|{FarmNo}|{Portion}|{Address}|{PropertyDescription}|{PropertyOwner}|{PropertyValuationMethod}|{PropertyExtentSize}|{PropertyValuation}|{ObjectionPeriod}|{AppealsPeriod}|{CurrentDate}|{ApplicationDescription}|{ApplicationCurrentStep}|{ApplicationStartDate}|{ApplicationCreatedDate}|{ApplicationCreatedByName}|{ApplicationCreatedBySurname}|{ApplicationPhase}|{ApplicationLastEditedByName}|{ApplicationLlastEditedBySurname}|{Rejector}/gi, (searchWord) => {
            let result = "";
            switch (searchWord) {
                case "{AppId}":
                    result = appId;
                    return result;
                case "{JobId}":
                    result = jobId;
                    return result;
                case "{ApplicantEmail}":
                    result = applicantEmail;
                    return result;
                case "{ApplicantName}":
                    result = applicantName;
                    return result;
                case "{ApplicantPhoneNo}":
                    result = applicantTelephone;
                    return result;
                case "{ApplicantSurname}":
                    result = applicantSurname;
                    return result;
                case "{ApplicantAgentEmail}":
                    result = applicantAgentEmail;
                    return result;
                case "{ApplicantAgentName}":
                    result = applicantAgentName;
                    return result;
                case "{ApplicantAgentPhoneNo}":
                    result = applicantAgentTelephone;
                    return result;
                case "{ApplicantAgentSurname}":
                    result = applicantAgentSurname;
                    return result;
                case "{RefNo}":
                    result = referenceNumber;
                    return result;
                case "{ReferenceNumber}":
                    result = referenceNumber;
                    return result;
                case "{UserName}":
                    result = userName;
                    return result;
                case "{UserSurname}":
                    result = userSurname;
                    return result;
                case "{UserEmail}":
                    result = userEmail;
                    return result;
                case "{UserPhoneNo}":
                    result = phoneNumber;
                    return result;
                case "{ModuleId}":
                    result = moduleId;
                    return result;
                case "{ModuleName}":
                    result = moduleName;
                    return result;
                case "{OrganisationName}":
                    result = organisationName;
                    return result;
                case "{Status}":
                    result = status;
                    return result;
                case "{Category}":
                    result = category;
                    return result;
                case "{PercentageComplete}":
                    result = percentageComplete;
                    return result;
                case "{LINK_TO_SURVEY_URL}":
                    result = linkToReplace;
                    return result;
                case "{LINK_TO_APPLICATION_URL}":
                    result = applicationAHref;
                    return result;
                case "{LINK_TO_REQUEST_COMMENT_URL}":
                    result = requestCommentAHref;
                    return result;
                case "{viewDocumentsLink}":
                    result = viewDocumentsAHref;
                    return result;
                case "{GraveID}":
                    result = graveId;
                    return result;
                case "{PlotNumber}":
                    result = plotNumber;
                    return result;
                case "{CemeteryName}":
                    result = cemeteryName;
                    return result;
                case "{ErfNumber}":
                    result = erfNo;
                    return result;
                case "{FarmNo}":
                    result = farmNo;
                    return result;
                case "{Portion}":
                    result = portion;
                    return result;
                case "{Address}":
                    result = address;
                    return result;
                case "{PropertyDescription}":
                    result = applicationDescription;
                    return result;
                case "{PropertyOwner}":
                    result = propertyOwner;
                    return result;
                case "{PropertyValuationMethod}":
                    result = propertyValuationMethod;
                    return result;
                case "{PropertyExtentSize}":
                    result = propertyExtentSize;
                    return result;
                case "{PropertyValuation}":
                    result = propertyValuation;
                    return result;
                case "{ObjectionPeriod}":
                    result = objectionPeriod;
                    return result;
                case "{AppealsPeriod}":
                    result = appealsPeriod;
                    return result;
                case "{CurrentDate}":
                    result = this.saShortDatePipe.transform(new Date());
                    return result;
                case "{ApplicationDescription}":
                    result = applicationDescription;
                    return result;
                case "{ApplicationCurrentStep}":
                    result = this.currentStepName;
                    return result;
                case "{ApplicationStartDate}":
                    result = applicationStartDate;
                    return result;
                case "{ApplicationCreatedDate}":
                    result = applicationCreatedDate;
                    return result;
                case "{ApplicationCreatedByName}":
                    result = applicationCreatedByName;
                    return result;
                case "{ApplicationCreatedBySurname}":
                    result = applicationCreatedBySurname;
                    return result;
                case "{ApplicationPhase}":
                    result = applicationPhase;
                    return result;
                case "{ApplicationLastEditedByName}":
                    result = applicationLastEditedByName;
                    return result;
                case "{ApplicationLastEditedBySurname}":
                    result = applicationLastEditedBySurname;
                    return result;
                case "{Rejector}":
                    result = rejector;
                    return result;
            }
        });
        return replacedText;
    }
    logEmailCommunication(updateRecipients) {
        let recipientsToUpdate;
        if (updateRecipients) {
            recipientsToUpdate = this.removeUnwantedProperties();
        }
        const communicationId = null;
        const attachmentsDefault = this.attachments;
        attachmentsDefault.forEach((att) => {
            delete att["allowAccess"];
        });
        const commmunication = {
            communicationType: this.communicationType,
            jobId: +this.attachmentManagerJobId,
            communicationMechanism: this.emailCommMechConst,
            direction: this.emailCommDirectionConst,
            relatedCommunicationId: communicationId,
            description: this.description,
            recipients: recipientsToUpdate,
            attachments: attachmentsDefault,
            deleted: false
        };
        const step = this.currentStepService.currentStep;
        this.logCommunicationSubscription =
            this.sendLetterService.logCommunication(commmunication, this.appController.selectedJobID, step.name, step.id)
                .subscribe({
                next: () => {
                    this.sendEmailForm.reset();
                    this.populateEmailSender();
                    this.selectedTemplateFromDropdown = undefined;
                    this.emailSent.emit(true);
                },
                error: (error) => {
                    this.appController.showMessage(SendEmailConstants.ERROR_LOGGING_EMAIL, AlertType.Error);
                }
            });
    }
    setEmailReceiverAddresses() {
        if (this.recipients) {
            this.toEmail = [];
            this.ccEmail = [];
            this.bccEmail = [];
            this.recipients.forEach((recipient) => {
                this.setEmailAddress(recipient);
                if (recipient.hasOwnProperty(this.emailFieldTextPlaceholder)) {
                    switch (recipient.typeValue) {
                        case "To":
                            this.toEmail.push(recipient.email);
                            break;
                        case "Cc":
                            this.ccEmail.push(recipient.email);
                            break;
                        case "Bcc":
                            this.bccEmail.push(recipient.email);
                            break;
                    }
                    this.description += "To " + this.toEmail + " " + "\r\n";
                    this.description += "Cc " + this.ccEmail + " " + "\r\n";
                    this.description += "Bcc " + this.bccEmail + " " + "\r\n";
                }
                else {
                    this.description += "To " + this.toEmail + " " + "\r\n";
                }
            });
        }
    }
    getEmailSender() {
        const emailSender = this.sendEmailForm.get(this.emailSenderControl).value;
        this.description = "From: " + emailSender + "\r\n";
        return emailSender;
    }
    setEmailAddress(recipient) {
        if (recipient.email) {
            this.toEmail.push(recipient.email);
        }
    }
    getEmailText() {
        const emailBody = this.sendEmailForm.get(this.emailTextControl).value;
        this.description += "Body: " + emailBody + "\r\n";
        return emailBody;
    }
    getAttachmentIds() {
        const emailAttachmentIds = [];
        this.attachments = [];
        this.description += "Attachments: ";
        if (this.sendEmailForm.get(this.attachmentManagerFormControl).value) {
            if (this.sendEmailForm.get(this.attachmentManagerFormControl).value.attachmentList.attachmentList.length > 0) {
                this.sendEmailForm.get(this.attachmentManagerFormControl).value.attachmentList.attachmentList.forEach((attachment) => {
                    this.description += attachment.fileName + ";";
                    delete attachment.file;
                    this.attachments.push(attachment);
                    emailAttachmentIds.push(attachment.id);
                });
            }
        }
        if (this.addDefaultTemplateChecked) {
            this.description += this.selectedTemplateFromDropdown.attachmentName + ";";
            emailAttachmentIds.push(this.selectedTemplateFromDropdown.attachmentId);
        }
        return emailAttachmentIds;
    }
    getAttachments() {
        const emailAttachmentIds = [];
        this.attachments = [];
        this.description += "Attachments: ";
        if (this.sendEmailForm.get(this.attachmentManagerFormControl).value) {
            if (this.sendEmailForm.get(this.attachmentManagerFormControl).value.attachmentList.attachmentList.length > 0) {
                this.sendEmailForm.get(this.attachmentManagerFormControl).value.attachmentList.attachmentList.forEach((attachment) => {
                    this.description += attachment.fileName + ";";
                    delete attachment.file;
                    this.attachments.push(attachment);
                    emailAttachmentIds.push({ id: attachment.id, anonymousAccess: attachment.allowAccess });
                });
            }
        }
        if (this.addDefaultTemplateChecked) {
            this.description += this.selectedTemplateFromDropdown.attachmentName + ";";
            emailAttachmentIds.push({ id: this.selectedTemplateFromDropdown.attachmentId, anonymousAccess: false });
        }
        return emailAttachmentIds;
    }
    getEmailSubject() {
        const emailSubject = this.sendEmailForm.get(this.emailSubjectControl).value;
        this.description += "Subject: " + emailSubject + "\r\n";
        return emailSubject;
    }
    generateEmail(emailSender, emailSubject, emailBody, emailAttachmentIds, anonymousAccess) {
        const params = {
            fromAddress: emailSender,
            subject: emailSubject,
            body: emailBody,
            attachmentIds: emailAttachmentIds,
            toAddresses: this.toEmail,
            ccAddresses: this.ccEmail,
            bccAddresses: this.bccEmail,
            isBodyHtml: true,
            anonymousDocumentAccess: anonymousAccess.anonymousDocumentAccess,
            anonymousDocumentAccessAllSelected: anonymousAccess.allDocumentsSelectedAnonymousAccess,
            anonymousDocumentAccessExpiryDays: anonymousAccess.daysBeforeAnonymousAccessExpiry,
            requestComment: null
        };
        if (this.isCommentRequestStep) {
            params.requestComment = { CommentRequestGuid: this.commentRequestGuid, AnonymousAccess: true };
        }
        let obs;
        if (this.currentStepType === SendEmailConstants.CURRENT_STEP_NAMES.SendSection49NoticesStep) {
            obs = this.sendEmailService.postSection49NoticesEmail(params);
        }
        else if (this.currentStepType === SendEmailConstants.CURRENT_STEP_NAMES.GenCreateNoticeStep) {
            const noticeParams = {
                fromAddress: emailSender,
                subject: emailSubject,
                body: emailBody,
                attachmentIds: [],
                toAddresses: this.toEmail,
                ccAddresses: this.ccEmail,
                bccAddresses: this.bccEmail,
                isBodyHtml: true,
                anonymousDocumentAccess: anonymousAccess.anonymousDocumentAccess,
                anonymousDocumentAccessAllSelected: anonymousAccess.allDocumentsSelectedAnonymousAccess,
                anonymousDocumentAccessExpiryDays: anonymousAccess.daysBeforeAnonymousAccessExpiry,
                requestComment: null,
                jobId: this.attachmentManagerJobId,
                templateId: this.selectedTemplateFromDropdown.id,
                templateName: this.selectedTemplateFromDropdown.name,
                attachmentType: this.attachmentManagerAttachmentType,
                componentType: this.currentStepName,
                recipients: this.recipients
            };
            obs = this.sendEmailService.sendNotice(noticeParams);
        }
        else {
            obs = this.sendEmailService.postEmail(params);
        }
        this.postEmailSubscription = obs
            .subscribe({
            next: () => {
                this.appController.showMessage(this.emailSentMsg, AlertType.Success);
                this.logEmailCommunication(true);
            },
            error: (error) => {
                const errorMessage = this.extractErrorMessage(error);
                if (errorMessage) {
                    this.appController.showMessage(errorMessage, AlertType.Error);
                }
                else {
                    this.appController.showMessage(SendEmailConstants.ERROR_SENDING_EMAIL, AlertType.Error);
                }
            }
        });
    }
    extractErrorMessage(error) {
        let errorMessage;
        if (error && error.error) {
            if (typeof error.error === "string") {
                const errorString = error.error;
                const startIndex = errorString.indexOf("Error: ") + "Error: ".length;
                const endIndex = errorString.indexOf("\r\n", startIndex);
                if (startIndex !== -1 && endIndex !== -1) {
                    errorMessage = errorString.substring(startIndex, endIndex);
                }
                else {
                    errorMessage = errorString;
                }
            }
            else if (error.error.message) {
                errorMessage = error.error.message;
            }
            else {
                errorMessage = SendEmailConstants.ERROR_SENDING_EMAIL;
            }
        }
        else {
            errorMessage = SendEmailConstants.ERROR_SENDING_EMAIL;
        }
        return errorMessage;
    }
    removeUnwantedProperties() {
        const recipientsToUpdate = this.recipients;
        recipientsToUpdate.forEach((recipient) => {
            recipient = RecipientUtils.removeRecipientProperties(recipient);
        });
        return recipientsToUpdate;
    }
    autoSendEmail() {
        if (this.autoSendDetails) {
            let recipientEmail;
            let emailSubject;
            let emailBody;
            const emailSender = this.sendEmailForm.get(this.emailSenderControl).value;
            this.description = "From: " + emailSender + "\r\n";
            if (this.autoSendDetails.hasOwnProperty("recipient")) {
                recipientEmail = this.autoSendDetails.recipient;
                this.description = "To: " + recipientEmail + "\r\n";
            }
            if (this.autoSendDetails.hasOwnProperty("subject")) {
                emailSubject = this.autoSendDetails.subject;
                this.description += "Subject: " + emailSubject + "\r\n";
            }
            if (this.autoSendDetails.hasOwnProperty("body")) {
                emailBody = this.autoSendDetails.body;
                this.description += "Body: " + emailBody + "\r\n";
            }
            const params = {
                fromAddress: emailSender,
                subject: emailSubject,
                body: emailBody,
                toAddresses: [recipientEmail],
                isBodyHtml: true
            };
            this.postEmailSubscription =
                this.sendEmailService.postEmail(params)
                    .subscribe({
                    next: () => {
                        this.appController.showMessage(this.emailSentMsg, AlertType.Success);
                        this.logEmailCommunication(false);
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Add);
                    }
                });
        }
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.attachmentManagerJobId} and moduleId eq ${+this.appController.selectedModuleID}`,
            $expand: this.aflaModuleStrategyService.getSelectedApplicationSummaryExpand()
        };
        this.getApplicationsQuerySubscription = this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe({
            next: (returnValue) => {
                this.application = returnValue.value[0];
                if (this.application.properties && this.application.properties.length > 0) {
                    this.properties = this.application.properties;
                }
                this.getApplicationStatusSubscription = this.appController.getApplicationStatus(this.application.jobId).subscribe({
                    next: (statuses) => {
                        if (statuses.value.length > 0) {
                            this.applicationStatus = statuses.value[0];
                        }
                    },
                    error: (error => {
                        this.appController.handleServerErrorMessage("Get application status", error, CRUDOperation.Get);
                    })
                });
            },
            error: (error => {
                this.appController.handleServerErrorMessage("send-email", error, CRUDOperation.Get);
            })
        });
    }
    static ctorParameters = () => [
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: ChangeDetectorRef },
        { type: UserInformationService },
        { type: SendEmailService },
        { type: AflaModuleStrategyService },
        { type: SendLetterService },
        { type: AppControllerService },
        { type: SaShortDatePipe },
        { type: WorkflowJobService },
        { type: CurrentStepService },
        { type: UserInformationService }
    ];
    static propDecorators = {
        recipients: [{ type: Input }],
        currentStepName: [{ type: Input }],
        hideAddDefaultTemplate: [{ type: Input }],
        hideAttachmentManager: [{ type: Input }],
        attachmentManagerAttachmentType: [{ type: Input }],
        attachmentManagerTitle: [{ type: Input }],
        attachmentManagerJobId: [{ type: Input }],
        communicationType: [{ type: Input }],
        autoSendDetails: [{ type: Input }],
        linkToReplace: [{ type: Input }],
        sendEmailButtonDisabled: [{ type: Input }],
        infoLabel: [{ type: Input }],
        currentLink: [{ type: Input }],
        commentRequestGuid: [{ type: Input }],
        viewDocumentsRequestGuid: [{ type: Input }],
        anonymousAccess: [{ type: Input }],
        isCommentRequestStep: [{ type: Input }],
        emailSent: [{ type: Output }],
        configurationName: [{ type: Input }],
        hideAddAttachmentButton: [{ type: Input }],
        hideDeleteAttachmentButton: [{ type: Input }],
        hideFilter: [{ type: Input }],
        hideAdd: [{ type: Input }],
        hideDelete: [{ type: Input }],
        allowPropertySelector: [{ type: Input }],
        templateRequired: [{ type: Input }],
        currentStepType: [{ type: Input }]
    };
};
SendEmailComponent = __decorate([
    Component({
        selector: "app-send-email",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SendEmailComponent);
export { SendEmailComponent };
